import * as React from 'react';
import { Link } from 'react-router-dom';
import { LocalizedText } from 'bernie-l10n';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

export interface BackLinkProps {
  backToHsrUrl: string;
  goBack: (e) => void;
  iconSize?: UitkIconSize;
  className?: string;
}

export const BackLink: React.FunctionComponent<BackLinkProps> = ({ backToHsrUrl, goBack, iconSize = UitkIconSize.MEDIUM, className }) => (
  <div className={`${className} uitk-grid`}>
    <UitkLink className="uitk-cell all-cell-shrink" iconPos={UitkLinkAlign.LEFT}>
      <Link id="his__back-button" to={backToHsrUrl || ''} onClick={goBack}>
        <UitkIcon size={iconSize} name="arrow_back" />
        <LocalizedText message="hotels.infosite.back.arrow.title" />
      </Link>
    </UitkLink>
  </div>
);
